import { iRequest } from '../../utils/requestutil';

export async function query(payload) {
  return iRequest(`/iwms-basic/basic/owner/page`, {
    method: 'post',
    body: payload,
  });
}
